/*! @azure/msal-common v4.4.0 2021-06-29 */
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

var CcsCredentialType;

(function (CcsCredentialType) {
  CcsCredentialType["HOME_ACCOUNT_ID"] = "home_account_id";
  CcsCredentialType["UPN"] = "UPN";
})(CcsCredentialType || (CcsCredentialType = {}));

export { CcsCredentialType };